<div class="notification" [ngClass]="data.level">
  <div class="notification__icon-wrapper">
    <div class="notification__icon-box">
      <fa-icon [icon]="levelIcon[data.level]"></fa-icon>
    </div>
  </div>
  <div class="notification__content">
    <div class="notification__content-texts">
      <span class="text__md fw__500">{{ data.title }}</span>
      <span class="text__sm fw__400 caption">{{ data.message }}</span>
    </div>
    @if (data.actionBtn || (data.duration ?? 0) >= 3000) {
      <div matSnackBarActions class="notification__content-actions">
        @if (data.actionBtn) {
          <eiq-button
            [text]="data.actionBtn"
            [style]="'basic'"
            [color]="'primary'"
            [testId]="'notification-action'"
            (clicked)="onDismissWithAction()"
          ></eiq-button>
        }
        @if ((data.duration ?? 0) >= 3000) {
          <eiq-button
            [text]="data.dismissBtn || 'Dismiss'"
            [style]="'basic'"
            [color]="'light'"
            [testId]="'notification-dismiss'"
            (clicked)="onDismiss()"
          ></eiq-button>
        }
      </div>
    }
  </div>
</div>
